exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.basket-card[data-v-8813351c] {\n    width: 100%!important;\n}\n", ""]);

// exports
